module.exports = __webpack_public_path__ + "static/media/map-marker-slash.8b517c34.svg";